import styled from "styled-components"
import media from "styled-media-query"

import { colors } from "~/styles"
import { Logo } from "~/components/Header/styles"

export const Wrapper = styled.div`
  position: relative;

  background-color: #fff;

  .shape {
    width: calc(100% + 1px);
  }

  > ${Logo} {
    position: absolute;
    left: 5rem;
    bottom: 12rem;
    height: 5rem;
  }
`

export const Container = styled.div`
  background-color: #fff;

  ${media.greaterThan("medium")`
    display: flex;
  `}
`

export const Figure = styled.figure`
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const Content = styled.article`
  flex: 1;
  padding: 2rem;

  ${media.greaterThan("medium")`
    padding: 12rem 6rem;
  `}

  h1 {
    color: #ff5c00;
    font-size: 2.8rem;
    margin-bottom: 3rem;
  }

  p {
    color: #666;
    font-size: 1.4rem;
    margin-bottom: 3rem;
  }
`

export const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Branding = styled.div`
  position: relative;

  padding: 1.5rem;
  background-color: ${colors.primary};

  > .shape {
    display: none;
  }

  ${media.greaterThan("medium")`
    padding: 0;
    background-color: initial;

    > ${Logo} {
      position: absolute;
      top: 50%;
      left: 3rem;
      transform: translateY(-50%);

      width: 56px;
      height: 56px;
    }

    > .shape {
      display: block;
    }

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';

      width: 5px;
      height: 100%;
      background-color: #ff7500;
    }
  `}
`
